import React from "react";
import t from "babel-plugin-yate/macro";
import statusMap from "../config/creditListStatus";
import { RangeOfDays } from "./RangeOfDays";

const primaryStatus = ["anaf_ok", "approved", "done"];
const secondaryStatus = [
  "new",
  "awaiting_cb_consent",
  "awaiting_cb",
  "cb_ok",
  "awaiting_kyc",
  "ocr",
  "selfie",
  "kyc_ok",
  "kyc_ok_awaiting_address",
  "awaiting_anaf_consent",
  "awaiting_anaf",
  "manual_analysis",
  "analysis",
  "risk_manual_analysis",
  "risk_validated",
  "awaiting_esign",
  "signed",
  "rejected",
  "canceled",
];

const LendingRequestsStatusFilters = ({ statusFilter, onFilterChange }) => {
  return (
    <div className="flex justify-between items-center bg-white rounded border mb-4">
      <div className="flex flex-wrap flex-col md:flex-row w-full md:w-auto px-2">
        <button
          className={`leading-normal px-4 py-6 mt-1 border-${
            statusFilter === "all" ? "blue" : "transparent"
          } border-b-3 font-medium text-black`}
          onClick={() => onFilterChange({ status: "all" })}
        >
          {t`All`}
        </button>

        {primaryStatus.map((status) => (
          <button
            key={status}
            className={`leading-normal px-4 py-6 mt-1 border-${
              statusFilter === status ? "blue" : "transparent"
            } border-b-3 font-medium text-black`}
            onClick={() => onFilterChange({ status })}
          >
            {statusMap(status)?.text}
          </button>
        ))}

        <div className="relative max-w-xs m-auto md:m-0">
          <select
            className={`appearance-none bg-white px-4 py-6 mt-1 pr-8 rounded-none leading-tight font-medium text-black border-b-3 border-${
              secondaryStatus.filter(Boolean).indexOf(statusFilter) > -1
                ? "blue"
                : "transparent"
            }`}
            value={statusFilter}
            onChange={({ target: { value } }) =>
              onFilterChange({ status: value })
            }
          >
            <option value="all">{t`Other`}</option>

            {secondaryStatus.map((statusKey, i) => {
              return (
                <option key={`${i}-${statusKey}`} value={statusKey}>
                  {statusMap(statusKey)?.text}
                </option>
              );
            })}
          </select>

          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-grey-darker-3">
            <svg
              className="fill-current inline h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>

      <div className="px-2 mb-8 md:mb-0">
        <RangeOfDays />
      </div>
    </div>
  );
};

export default LendingRequestsStatusFilters;
